
import { Component, Mixins } from "vue-property-decorator";
import { default as StyledTextDrawableObjectMixin } from "./StyledTextDrawableObjectMixin.vue";
import FontSizeAutoAdjustableMixin from "./FontSizeAutoAdjustableMixin.vue";
import { default as TextFreeInputableMixin } from "./TextFreeInputableMixin.vue";
import StyledTextPositionDrawableMixin from "./StyledTextPositionDrawableMixin.vue";

@Component({
})
export default class StyledTextEditableObjectMixin extends Mixins(
  StyledTextDrawableObjectMixin,
  FontSizeAutoAdjustableMixin,
  TextFreeInputableMixin,
  StyledTextPositionDrawableMixin
) {
  get transformGeometryStyleProperties() {
    const scale = this.transformTextScale;
    const rectangle = this.geometry.rectangle;
    return {
      transform: "scale(" + scale + ")",
      transformOrigin: "top left",
      width: (rectangle.width / scale) + "px",
      height: (rectangle.height / scale) + "px",
    };
  }

  get transformTextStyleProperties() {
    const scale = this.transformTextScale;
    const height = this.textPositionStyleProperties.height;
    const lineHeight = this.getLineHeightValue();
    return {
      fontSize: this.baseTransformFontSize + "px",
      lineHeight: (!!lineHeight && lineHeight.indexOf("px") !== -1)
        ? (parseFloat(lineHeight.replace("px", "")) / scale) + "px"
        : this.textStyle.lineHeight.toString(),
      height: !!height
        ? (parseFloat(height.replace("px", "")) / scale) + "px"
        : null,
    };
  }

  get transformMeasureTextStyleProperties() {
    return {
      fontSize: this.baseTransformFontSize + "px",
      whiteSpace: this.textStyle.isMultiLine ? "pre-wrap" : "pre",
    };
  }
}
